/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_DATA_COPY,
  LOAD_DATA_COPY_SUCCESS,
  LOAD_DATA_COPY_ERROR,



  ADD_DATA_SCHEDULING,
  ADD_DATA_SCHEDULING_SUCCESS,
  ADD_DATA_SCHEDULING_ERROR,

  REMOVE_DATA_SERVICE,
  REMOVE_DATA_SERVICE_SUCCESS,
  REMOVE_DATA_SERVICE_ERROR,

  LOAD_DATA_SCHEDULING_SERVICE,
  LOAD_DATA_SCHEDULING_SERVICE_SUCCESS,
  LOAD_DATA_SCHEDULING_SERVICE_ERROR,

  LOAD_DATA_SCHEDULING_SUCCESS,
  LOAD_DATA_SCHEDULING_ERROR,
  LOAD_DATA_SCHEDULING,

  // LOAD_EVENT_TEAM_SCHEDULING_SUCCESS,
  // LOAD_EVENT_TEAM_SCHEDULING_ERROR,
  // LOAD_EVENT_TEAM_SCHEDULING,

  UPDATE_DATA_SCHEDULING,
  UPDATE_DATA_SCHEDULING_SUCCESS,
  UPDATE_DATA_SCHEDULING_ERROR,

  SHOOTER_HISTORY_LIST,
  SHOOTER_HISTORY_LIST_SUCCESS,
  SHOOTER_HISTORY_LIST_ERROR,

  DATA_FINAL_COMMIT,
  DATA_FINAL_COMMIT_SUCCESS,
  DATA_FINAL_COMMIT_ERROR,

  AGENT_VANCANY_LIST,
  AGENT_VANCANY_LIST_SUCCESS,
  AGENT_VANCANY_LIST_ERROR,

  AGENT_OFFICE_VACANCY_LIST,
  AGENT_OFFICE_VACANCY_LIST_SUCCESS,
  AGENT_OFFICE_VACANCY_LIST_ERROR,
  LOAD_NAS_LINK_DETAILS,
  LOAD_NAS_LINK_DETAILS_SUCCESS,
  LOAD_NAS_LINK_DETAILS_ERROR,
  ADD_NAS_LINK,
  ADD_NAS_LINK_SUCCESS,
  ADD_NAS_LINK_ERROR,
  UPDATE_NAS_LINK,
  UPDATE_NAS_LINK_SUCCESS,
  UPDATE_NAS_LINK_ERROR,
  DELETE_NAS_LINK,
  DELETE_NAS_LINK_SUCCESS,
  DELETE_NAS_LINK_ERROR,
  LOAD_DATA_LINK_DETAILS,
  LOAD_DATA_LINK_DETAILS_SUCCESS,
  LOAD_DATA_LINK_DETAILS_ERROR,
  ADD_DATA_LINK,
  ADD_DATA_LINK_SUCCESS,
  ADD_DATA_LINK_ERROR,
  UPDATE_DATA_LINK,
  UPDATE_DATA_LINK_SUCCESS,
  UPDATE_DATA_LINK_ERROR,
  DELETE_DATA_LINK,
  DELETE_DATA_LINK_SUCCESS,
  DELETE_DATA_LINK_ERROR,

  LOAD_SERVICE_LEVEL,
  LOAD_SERVICE_LEVEL_SUCCESS,
  LOAD_SERVICE_LEVEL_ERROR,

  UPLOAD_QC,
  UPLOAD_QC_SUCCESS,
  UPLOAD_QC_ERROR,

  UPDATE_NAS_COMMIT,
  UPDATE_NAS_COMMIT_SUCCESS,
  UPDATE_NAS_COMMIT_ERROR,

  LOAD_PENDING_STATUS,
  LOAD_PENDING_STATUS_SUCCESS,
  LOAD_PENDING_STATUS_ERROR,

  UPDATE_DATA_COPY,
  UPDATE_DATA_COPY_SUCCESS,
  UPDATE_DATA_COPY_ERROR,
  
  UPDATE_EXPAND,
  UPDATE_EXPAND_SUCCESS,
  UPDATE_EXPAND_ERROR,

  LOAD_DATA_DETAILS,
  LOAD_DATA_DETAILS_SUCCESS,
  LOAD_DATA_DETAILS_ERROR,

  LOAD_EXPAND_DATA,
  LOAD_EXPAND_DATA_SUCCESS,
  LOAD_EXPAND_DATA_ERROR

} from "./constants"
//LOAD_DATA_COPY
export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list    loadDataCopy
export function loadDataCopy(searchvalue) {
  return {
    type: LOAD_DATA_COPY,
    searchvalue,
  }
}
export function loadDataCopySuccess(data_copy_details) {
  return {
    type: LOAD_DATA_COPY_SUCCESS,
    data_copy_details,
  }
}
export function loadDataCopyError(error) {
  return {
    type: LOAD_DATA_COPY_ERROR,
    error,
  }
}

//Data scheduling section start


export function loadDataScheduling(id) {
  return {
    type: LOAD_DATA_SCHEDULING,
    id,
  }
}

export function loadDataSchedulingSuccess(data_scheduling_details) {
  return {
    type: LOAD_DATA_SCHEDULING_SUCCESS,
    data_scheduling_details,
  }
}



export function loadDataSchedulingError(error) {
  return {
    type: LOAD_DATA_SCHEDULING_ERROR,
    error,
  }
}
export function loadDataSchedulingService(record) {
  return {
    type: LOAD_DATA_SCHEDULING_SERVICE,
    record,
  }
}

export function loadDataSchedulingServiceSuccess(data_scheduling_services) {
  return {
    type: LOAD_DATA_SCHEDULING_SERVICE_SUCCESS,
    data_scheduling_services,
  }
}



export function loadDataSchedulingServiceError(error) {
  return {
    type: LOAD_DATA_SCHEDULING_SERVICE_ERROR,
    error,
  }
}


export function addDataScheduling(dataScheduling) {

  return {
    type: ADD_DATA_SCHEDULING,
    dataScheduling,
  }
}


export function addDataSchedulingSuccess(dataScheduling, success) {

  return {
    type: ADD_DATA_SCHEDULING_SUCCESS,
    dataScheduling,
    success,
  }
}


export function addDataSchedulingError(error) {
  return {
    type: ADD_DATA_SCHEDULING_ERROR,
    error,
  }
}

//Update team scheduling
export function updateDataScheduling(dataScheduling) {

  return {
    type: UPDATE_DATA_SCHEDULING,
    dataScheduling,
  }
}


export function updateDataSchedulingSuccess(dataScheduling, success) {

  return {
    type: UPDATE_DATA_SCHEDULING_SUCCESS,
    dataScheduling,
    success,
  }
}


export function updateDataSchedulingError(error) {
  return {
    type: UPDATE_DATA_SCHEDULING_ERROR,
    error,
  }
}

//Remove team scheduling
export function removeDataScheduling(dataScheduling) {

  return {
    type: REMOVE_DATA_SERVICE,
    dataScheduling,
  }
}


export function removeDataSchedulingSuccess(dataScheduling, success) {

  return {
    type: REMOVE_DATA_SERVICE_SUCCESS,
    dataScheduling,
    success,
  }
}


export function removeDataSchedulingError(error) {
  return {
    type: REMOVE_DATA_SERVICE_ERROR,
    error,
  }
}


//Final Commit
export function dataFinalCommit(finalCommit) {

  return {
    type: DATA_FINAL_COMMIT,
    finalCommit,
  }
}


export function dataFinalCommitSuccess(finalCommit, success) {

  return {
    type: DATA_FINAL_COMMIT_SUCCESS,
    finalCommit,
    success,
  }
}


export function dataFinalCommitError(error) {
  return {
    type: DATA_FINAL_COMMIT_ERROR,
    error,
  }
}

//Shooter History

export function loadShooterHistory(empId) {
  return {
    type: SHOOTER_HISTORY_LIST,
    empId,
  }
}

export function loadShooterHistorySuccess(shooter_history) {
  return {
    type: SHOOTER_HISTORY_LIST_SUCCESS,
    shooter_history,
  }
}



export function loadShooterHistoryError(error) {
  return {
    type: SHOOTER_HISTORY_LIST_ERROR,
    error,
  }
}

export function loadAgentVacancy(record) {
  return {
    type: AGENT_VANCANY_LIST,
    record,
  }
}

export function loadAgentVacancySuccess(agent_vacancy_details) {
  return {
    type: AGENT_VANCANY_LIST_SUCCESS,
    agent_vacancy_details,
  }
}



export function loadAgentVacancyError(error) {
  return {
    type: AGENT_VANCANY_LIST_ERROR,
    error,
  }
}

export function loadAgentOfficeVacancy(record) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST,
    record,
  }
}

export function loadAgentOfficeVacancySuccess(agent_office_details) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST_SUCCESS,
    agent_office_details,
  }
}



export function loadAgentOfficeVacancyError(error) {
  return {
    type: AGENT_OFFICE_VACANCY_LIST_ERROR,
    error,
  }
}
//Data scheduling section end

//Nas link section
export function loadNasLinkList(record) {
  return {
    type: LOAD_NAS_LINK_DETAILS,
    record,
  }
}

export function loadNasLinkListSuccess(nas_link_details) {
  return {
    type: LOAD_NAS_LINK_DETAILS_SUCCESS,
    nas_link_details,
  }
}



export function loadNasLinkListError(error) {
  return {
    type: LOAD_NAS_LINK_DETAILS_ERROR,
    error,
  }
}


export function addNasLink(nasLinkDetails) {

  return {
    type: ADD_NAS_LINK,
    nasLinkDetails,
  }
}


export function addNasLinkSuccess(nasLinkDetails, success) {

  return {
    type: ADD_NAS_LINK_SUCCESS,
    nasLinkDetails,
    success,
  }
}


export function addNasLinkError(error) {
  return {
    type: ADD_NAS_LINK_ERROR,
    error,
  }
}

//Update team scheduling
export function updateNasLink(nasLinkDetails) {

  return {
    type: UPDATE_NAS_LINK,
    nasLinkDetails,
  }
}


export function updateNasLinkSuccess(nasLinkDetails, success) {

  return {
    type: UPDATE_NAS_LINK_SUCCESS,
    nasLinkDetails,
    success,
  }
}


export function updateNasLinkError(error) {
  return {
    type: UPDATE_NAS_LINK_ERROR,
    error,
  }
}

//Remove nas link
export function removeNasLink(deleteNasLinkData) {

  return {
    type: DELETE_NAS_LINK,
    deleteNasLinkData,
  }
}


export function removeNasLinkSuccess(success) {

  return {
    type: DELETE_NAS_LINK_SUCCESS,
    success,
  }
}


export function removeNasLinkError(error) {
  return {
    type: DELETE_NAS_LINK_ERROR,
    error,
  }
}

//Data link section
export function loadDataLinkList(record) {
  return {
    type: LOAD_DATA_LINK_DETAILS,
    record,
  }
}

export function loadDataLinkListSuccess(data_link_details) {
  return {
    type: LOAD_DATA_LINK_DETAILS_SUCCESS,
    data_link_details,
  }
}



export function loadDataLinkListError(error) {
  return {
    type: LOAD_DATA_LINK_DETAILS_ERROR,
    error,
  }
}
//service level status  
export function loadServiceLevel(searchvalue) {
  return {
    type: LOAD_SERVICE_LEVEL,
    searchvalue,
  }
}

export function loadServiceLevelSuccess(serviceLevel_details) {
  return {
    type: LOAD_SERVICE_LEVEL_SUCCESS,
    serviceLevel_details,
  }
}



export function loadServiceLevelError(error) {
  return {
    type: LOAD_SERVICE_LEVEL_ERROR,
    error,
  }
}

export function addDataLink(dataLinkDetails) {

  return {
    type: ADD_DATA_LINK,
    dataLinkDetails,
  }
}


export function addDataLinkSuccess(dataLinkDetails, success) {

  return {
    type: ADD_DATA_LINK_SUCCESS,
    dataLinkDetails,
    success,
  }
}


export function addDataLinkError(error) {
  return {
    type: ADD_DATA_LINK_ERROR,
    error,
  }
}

//Update team scheduling
export function updateDataLink(dataLinkDetails) {

  return {
    type: UPDATE_DATA_LINK,
    dataLinkDetails,
  }
}


export function updateDataLinkSuccess(dataLinkDetails, success) {

  return {
    type: UPDATE_DATA_LINK_SUCCESS,
    dataLinkDetails,
    success,
  }
}


export function updateDataLinkError(error) {
  return {
    type: UPDATE_DATA_LINK_ERROR,
    error,
  }
}

//Remove nas link
export function removeDataLink(dataLinkDetails) {

  return {
    type: DELETE_DATA_LINK,
    dataLinkDetails,
  }
}


export function removeDataLinkSuccess(dataLinkDetails, success) {

  return {
    type: DELETE_DATA_LINK_SUCCESS,
    dataLinkDetails,
    success,
  }
}


export function removeDataLinkError(error) {
  return {
    type: DELETE_DATA_LINK_ERROR,
    error,
  }
}
//uploadQc
export function uploadQc(qcDetails) {

  return {
    type: UPLOAD_QC,
    qcDetails,
  }
}


export function uploadQcSuccess(success) {

  return {
    type: UPLOAD_QC_SUCCESS,
    success,
  }
}


export function uploadQcError(error) {
  return {
    type: UPLOAD_QC_ERROR,
    error,
  }
}

//updateNasCommit
export function updateNasCommit(nasCommitDetails) {

  return {
    type: UPDATE_NAS_COMMIT,
    nasCommitDetails,
  }
}


export function updateNasCommitSuccess(success) {

  return {
    type: UPDATE_NAS_COMMIT_SUCCESS,
    success,
  }
}


export function updateNasCommitError(error) {
  return {
    type: UPDATE_NAS_COMMIT_ERROR,
    error,
  }
}
//loadPendingStatus 
export function loadPendingStatus(pendingDetails) {
  return {
    type: LOAD_PENDING_STATUS,
    pendingDetails,
  }
}

export function loadPendingStatusSuccess(pendingData) {
  return {
    type: LOAD_PENDING_STATUS_SUCCESS,
    pendingData,
  }
}



export function loadPendingStatusError(error) {
  return {
    type: LOAD_PENDING_STATUS_ERROR,
    error,
  }
}

//updateNasCommit
export function updateCopy(copyDetails) {

  return {
    type: UPDATE_DATA_COPY,
    copyDetails,
  }
}


export function updateCopySuccess(success) {

  return {
    type: UPDATE_DATA_COPY_SUCCESS,
    success,
  }
}


export function updateCopyError(error) {
  return {
    type: UPDATE_DATA_COPY_ERROR,
    error,
  }
}

//
export function updateExpand(expandDetails) {

  return {
    type: UPDATE_EXPAND,
    expandDetails,
  }
}


export function updateExpandSuccess(success) {

  return {
    type: UPDATE_EXPAND_SUCCESS,
    success,
  }
}


export function updateExpandError(error) {
  return {
    type: UPDATE_EXPAND_ERROR,
    error,
  }
}

//loadDataDetails
export function loadDataDetails(dataService) {
  return {
    type: LOAD_DATA_DETAILS,
     dataService,
  }
}

export function loadDataDetailsSuccess(dataDetails) {
  return {
    type: LOAD_DATA_DETAILS_SUCCESS,
    dataDetails,
  }
}
export function loadDataDetailsError(error) {
  return {
    type: LOAD_DATA_DETAILS_ERROR,
    error,
  }
}
//
//loadExpandData
export function loadExpandData(pendingDetails) {
  return {
    type: LOAD_EXPAND_DATA,
    pendingDetails,
  }
}

export function loadExpandDataSuccess(expandData) {
  return {
    type: LOAD_EXPAND_DATA_SUCCESS,
    expandData,
  }
}



export function loadExpandDataError(error) {
  return {
    type: LOAD_EXPAND_DATA_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadDataCopy,
  loadDataCopySuccess,
  loadDataCopyError,

  loadDataScheduling,
  loadDataSchedulingSuccess,
  loadDataSchedulingError,

  addDataScheduling,
  addDataSchedulingError,
  addDataSchedulingSuccess,

  loadDataSchedulingService,
  loadDataSchedulingServiceSuccess,
  loadDataSchedulingServiceError,

  updateDataScheduling,
  updateDataSchedulingError,
  updateDataSchedulingSuccess,
  removeDataScheduling,
  removeDataSchedulingSuccess,
  removeDataSchedulingError,


  //Nas link
  loadNasLinkList,
  loadNasLinkListSuccess,
  loadNasLinkListError,

  addNasLink,
  addNasLinkError,
  addNasLinkSuccess,

  updateNasLink,
  updateNasLinkSuccess,
  updateNasLinkError,

  removeNasLink,
  removeNasLinkSuccess,
  removeNasLinkError,

  //Data link
  loadDataLinkList,
  loadDataLinkListSuccess,
  loadDataLinkListError,

  addDataLink,
  addDataLinkError,
  addDataLinkSuccess,

  updateDataLink,
  updateDataLinkSuccess,
  updateDataLinkError,

  removeDataLink,
  removeDataLinkSuccess,
  removeDataLinkError,

  loadServiceLevel,
  loadServiceLevelSuccess,
  loadServiceLevelError,

  uploadQc,
  uploadQcSuccess,
  uploadQcError,

  updateNasCommit,
  updateNasCommitSuccess,
  updateNasCommitError,

  loadPendingStatus,
  loadPendingStatusSuccess,
  loadPendingStatusError,

  updateCopy,
  updateCopySuccess,
  updateCopyError,

  updateExpand,
  updateExpandSuccess,
  updateExpandError,

  loadDataDetails,
  loadDataDetailsSuccess,
  loadDataDetailsError

}

export default actions
